import { SubmissionList } from './list'

export default { SubmissionList }
